import React from 'react';
import { withRouter } from 'react-router-dom';

import { ACTION } from 'constants/index';

import ApplicationActions from 'Components/ApplicationActions';

import Header from './Header';
import BasicInfo from './BasicInfo';
import BoatInfo from './BoatInfo';
import GeneralInfo from './GeneralInfo';
import BoatSystems from './BoatSystems';
import BoatWeight from './BoatWeight';
import CubicCapacity from './CubicCapacity';
import PersonWeightCapacity from './PersonWeightCapacity';
import PowerCapacity from './PowerCapacity';
import BoatFlotation from './BoatFloatation';
import AdditionalDocuments from './AdditionalFiles';
import BoatStatus from './BoatStatus';

import Store from '../../../../../registerIDBWorker';

@withRouter
export default class Details extends React.Component {
  $$disablePrint = event => {
    event.preventDefault();
  };

  performAction = actionKey => () => {
    const {selectAction, boat, user} = this.props;

    selectAction(actionKey, boat)
      .then((updatedData) => {
        if (actionKey !== ACTION.DELETE) {
          this.updateListEntry(updatedData);
          this.forceUpdate();
        } else {
          this.deleteListEntry(boat);
          user.goToList();
        }
      });
  };

  updateListEntry = (newEntry) => {
    const {user, boat, updateBoatDetails} = this.props;

    let dataSource = newEntry.status ? newEntry : {...boat, status: newEntry};
    let newListEntry = {
      boatType: dataSource.boatType,
      engineType: dataSource.engineType,
      id: dataSource.id,
      lengthFeet: dataSource.boatSpecifications.lengthFeet,
      lengthInches: dataSource.boatSpecifications.lengthInches,
      name: dataSource.boatSpecifications.name,
      status: dataSource.status,
      submittedOn: dataSource.submittedOn,
      user: '',
      year: dataSource.boatSpecifications.year,
    };

    Store.insert(`${user.getActiveRole()}_lists`, newListEntry, user.getManufacturerCode());
    updateBoatDetails(dataSource);
  };

  deleteListEntry = oldEntry => {
    const {user} = this.props;

    Store.delete(`${user.getActiveRole()}_lists`, oldEntry);
  };

  _goBack = () => {
    const {user, history} = this.props;

    if (history.length === 1) {
      user.goToList();
    } else {
      user.goBack();
    }
  };

  render() {
    const {user, boat, createActionsList, boatDetailsRequestInProcess} = this.props;
    const actionsList = createActionsList(boat);

    const canEdit = actionsList.find(act => act === ACTION.EDIT) && !user.isInspector();
    const canDelete = actionsList.find(act => act === ACTION.DELETE) && !user.isInspector();

    return (
      <a id='print-link' onClick={this.$$disablePrint} href='javascript:window.print()'>
        <section className='scene__scene-wrapper'>
          <section
            className={`scene__content-wrapper detailsScene__content-wrapper ${boat.status.toLowerCase()}
          ${document.documentMode || /Edge/.test(navigator.userAgent) ? 'display-block-on-print' : ''}`}
          >
            <Header
              applicationStatus={boat.status}
              boat={boat}
              canEdit={canEdit}
              canDelete={canDelete}
              loadInProgress={boatDetailsRequestInProcess}
              performAction={this.performAction}
              user={user}
            />
            <BasicInfo boat={boat} boatDetailsRequestInProcess={boatDetailsRequestInProcess} />
            <BoatInfo
              boatSpecifications={boat.boatSpecifications}
              boatDetailsRequestInProcess={boatDetailsRequestInProcess}
            />
            <GeneralInfo
              boatSpecifications={boat.boatSpecifications}
              dualSteering={boat.dualSteering}
              boatDetailsRequestInProcess={boatDetailsRequestInProcess}
            />
            <BoatSystems boatSystems={boat.boatSystems} boatDetailsRequestInProcess={boatDetailsRequestInProcess} />
            <CubicCapacity
              cubicCapacity={boat.cubicCapacity}
              boatType={boat.boatType}
              boatDetailsRequestInProcess={boatDetailsRequestInProcess}
            />
            <BoatWeight
              plateType={boat.plateType}
              personPowerCapacity={boat.personPowerCapacity}
              boatDetailsRequestInProcess={boatDetailsRequestInProcess}
            />
            <PersonWeightCapacity
              personPowerCapacity={boat.personPowerCapacity}
              boatDetailsRequestInProcess={boatDetailsRequestInProcess}
            />
            <PowerCapacity
              powerCapacity={boat.powerCapacity}
              boatDetailsRequestInProcess={boatDetailsRequestInProcess}
            />
            <BoatFlotation
              floatationCapacity={boat.floatationCapacity}
              applicationId={boat.id}
              boatDetailsRequestInProcess={boatDetailsRequestInProcess}
            />
            <AdditionalDocuments
              additionalFiles={boat.additionalFiles}
              applicationId={boat.id}
              boatDetailsRequestInProcess={boatDetailsRequestInProcess}
            />
            {!!actionsList.length && (
              <BoatStatus
                actionsList={actionsList}
                canEdit={canEdit}
                performAction={this.performAction}
                user={user}
                boat={boat}
                boatDetailsRequestInProcess={boatDetailsRequestInProcess}
              />
            )}
            <ApplicationActions
              backButtonAction={this._goBack}
              backButtonLabel='Back'
              boatDetailsRequestInProcess={boatDetailsRequestInProcess}
            />
          </section>
        </section>
      </a>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/BoatManufacturer/Application/Details/index.jsx